<template>
<div>
    <business-partner-responsible-form :getBusinessPartnerResponsibleList="getBusinessPartnerResponsibleList" ref="businessPartnerResponsibleFormModal"></business-partner-responsible-form>
    <b-row>
        <b-col class="col-12">
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('businessPartnerResponsible.add') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="businessPartnerResponsibleTable" ref="businessPartnerResponsibleTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'name'" class="text-nowrap">
                {{ $t('businessPartnerResponsible.name') }}
            </span>
            <span v-else-if="props.column.field === 'surname'" class="text-nowrap">
                {{ $t('businessPartnerResponsible.surname') }}
            </span>
            <span v-else-if="props.column.field === 'email'" class="text-nowrap">
                {{ $t('businessPartnerResponsible.email') }}
            </span>
            <span v-else-if="props.column.field === 'telephone'" class="text-nowrap">
                {{ $t('businessPartnerResponsible.telephone') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        businessPartnerId: Number,
    },
    data() {
        return {
            dir: false,
            columns: [{
                    label: this.$t('businessPartnerResponsible.name'),
                    field: `name`,
                },
                {
                    label: this.$t('businessPartnerResponsible.surname'),
                    field: `surname`,
                },
                {
                    label: this.$t('businessPartnerResponsible.email'),
                    field: `email`,
                },
                {
                    label: this.$t('businessPartnerResponsible.telephone'),
                    field: `telephone`,
                },
                {
                    label: '',
                    field: 'process',
                    width: '10em',
                    sortable: false
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getBusinessPartnerResponsibleList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'BusinessPartnerResponsible'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getBusinessPartnerResponsibleList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getBusinessPartnerResponsibleList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.businessPartnerResponsibleFormModal.showInfo(id,this.businessPartnerId)
        },
        getBusinessPartnerResponsibleList() {
            this.rows = []
            const data = {
                id: this.businessPartnerId
            }
            const controller = {
                name: 'BusinessPartnerResponsible',
                actionName: 'GetBusinessPartnerResponsibleListByBusinessPartnerId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.businessPartnerResponsibleList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
